import { StyleSheet } from 'react-native';
import { ColorTypography } from 'src/theme-v2/color-typography';
import { CornerRadius } from 'src/theme-v2/corner-radius';
import { Spacing } from 'src/theme-v2/spacing';
import { textLatoStyleDS } from 'src/theme-v2/text';
import { neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  tooltip: {
    paddingVertical: Spacing.Cozy,
    paddingRight: Spacing.Compact,
    paddingLeft: Spacing.Cozy,
    gap: Spacing.Compact,
    width: 370,
    flexDirection: 'row',
  },
  closeIcon: {
    color: neutrals.neutralGrays.grey,
  },
  content: {
    flex: 1,
    gap: Spacing.Tight,
  },
  tooltipTitle: {
    ...textLatoStyleDS.TitleBoldLg,
    color: ColorTypography.TextColorPrimary,
  },
  entries: {
    flex: 1,
    gap: Spacing.Compact,
  },
  entry: {
    gap: Spacing.Micro,
  },
  entryTitle: {
    ...textLatoStyleDS.BodyBoldSm,
    color: ColorTypography.TextColorPrimary,
  },
  entryElem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  bullet: {
    width: 5,
    height: 5,
    marginHorizontal: Spacing.Condensed,
    borderRadius: 30,
    backgroundColor: neutrals.black,
  },
  entryVoice: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  entryText: {
    ...textLatoStyleDS.BodyRegularXs,
    color: ColorTypography.TextColorPrimary,
  },
  entryInfo: {
    flexDirection: 'row',
    gap: Spacing.Condensed,
    alignItems: 'center',
  },
  entryDiscount: {
    paddingHorizontal: Spacing.Micro,
    paddingVertical: Spacing.Supermicro,
    backgroundColor: ColorTypography.TextColorAccent,
    borderRadius: CornerRadius.Micro,
    color: ColorTypography.TextColorOnDark,
    ...textLatoStyleDS.BodyBoldXs,
  },
  entryOriginal: {
    ...textLatoStyleDS.BodyRegularXs,
    textDecorationLine: 'line-through',
    color: ColorTypography.TextColorPrimary,
  },
  entryEstimate: {
    ...textLatoStyleDS.BodyBoldSm,
    color: ColorTypography.TextColorPrimary,
  },
});
